<template>
  <Select
    v-model="selectedItem"
    :filter="props.data.filter"
    :options="optionsList"
    option-label="name"
    :placeholder="$t('pleaseSelect')"
    :class="[props.data.errorMessage ? 'invalid' : 'valid', props.data.elementClasses ]"
    :invalid="props.data.errorMessage ? true : false"
    :disabled="props.data.disabled"
    :loading="isLoading"
    class="w-full"
    option-disabled="disabled"
    @change="($event) => {
      chooseOption($event)
    }"
  />
</template>

<script setup>
const selectedItem = ref(null)

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})

/**
* Emits
*/
const emit = defineEmits(['returnData'])

/**
* Is Loading
*/
const isLoading = ref(false)
const optionsResolved = ref([])

watch(() => props.data?.options, async (newOptions) => {
  if (newOptions instanceof Promise) {
    isLoading.value = true
    try {
      const resolved = await newOptions
      optionsResolved.value = resolved || []
    } finally {
      isLoading.value = false
    }
  } else if (Array.isArray(newOptions)) {
    optionsResolved.value = newOptions
    isLoading.value = false
  } else {
    optionsResolved.value = []
    isLoading.value = false
  }
}, { immediate: true, deep: true })

/*
* Options List
*/
const optionsList = computed(() => {
  const newArr = []
  if (optionsResolved.value && !isLoading.value) {
    optionsResolved.value.forEach((item) => {
      newArr.push({
        disabled: item.disabled ? true : false,
        code: typeof item.value === 'object' ? JSON.stringify(item.value) : item.value + '',
        name: item.name
      })
    })

    selectedItem.value = optionsList.value?.find(n => n.code === currentOption.value)
  }
  
  return newArr
})

/**
* Current Option
*/
const currentOption = computed({
  get() {
    return typeof props.data.formData[props.data.name] === 'object'
      ? JSON.stringify(props.data.formData[props.data.name])
      : props.data.formData[props.data.name] + ''
  }
})

/**
* Current Option
*/
watch(optionsList, (newOptionsList) => {
  selectedItem.value = newOptionsList?.find(n => n.code === currentOption.value)
}, { immediate: true, deep: true })

/**
* Choose Option
*/
const chooseOption = () => {
  const value = selectedItem.value?.code
  if (typeof value === 'string') {
    try {
      emit('returnData', JSON.parse(value))
      return
    } catch {
      // not a valid JSON, return as string
    }
  }

  emit('returnData', value)
}
</script>

<style lang="scss" scoped>
</style>
